import { render, staticRenderFns } from "./edit_tax.vue?vue&type=template&id=55d8b790&scoped=true"
import script from "./edit_tax.vue?vue&type=script&lang=js"
export * from "./edit_tax.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./edit_tax.vue?vue&type=style&index=1&id=55d8b790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d8b790",
  null
  
)

export default component.exports